





































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Auth } from '@finx/web-repository/src/services/Oidc'
import { getModule } from 'vuex-module-decorators'
import CadastroMedicoStore from '@/components/CadastroMedico/store/CadastroMedicoStore'
import SnackbarStore from '@/components/Snackbar/Store/SnackbarStore'
import { onlyNumber } from '@/utils/common'
import { TipoDocumentoUpload, ISnackbarValidation, TipoUsuarioEnum, Loading, RequestMessage, IRequestMessage } from '@/types/_'
import moment from 'moment'
import _ from 'lodash'
import { CadastroMedicoValidation, SecretariaMedicoValidation } from '@/components/CadastroMedico/store/Validation/Validation'

const tipoUsuario = TipoUsuarioEnum

interface VDatePicker extends Vue {
  save(date: any): any
}

@Component

export default class ViewCadastroMedico extends Vue {
  tipoUsuario: string = ''

  loading: Loading = {
    status: false,
    text: '',
  }

  get getCadastroMedicoStore() {
    return getModule(CadastroMedicoStore, this.$store)
  }

  get getSnackbarStore() {
    return getModule(SnackbarStore, this.$store)
  }

  get getTipoUsuario() {
    return this.tipoUsuario
  }

  set getTipoUsuario(value: string) {
    this.tipoUsuario = value
  }

  get getLoadingRequest() {
    return this.loading
  }

  set getLoadingRequest(value: Loading) {
    this.loading = value
  }

  get getRequestMessage() {
    const requestMessage: IRequestMessage = new RequestMessage()
    return requestMessage
  }

  clearLoadingRequest() {
    this.setLoadingRequest(false, '')
  }

  setLoadingRequest(status: boolean, text: string) {
    this.getLoadingRequest.status = status
    this.getLoadingRequest.text = text
  }

  closeSnackbar() {

  }

  isMedicoValid() {
    const cadastroMedicoValidation = new CadastroMedicoValidation()
    const cadastroMedicoMessage = cadastroMedicoValidation
      .isValid(this.getCadastroMedicoStore.cadastroMedico, this.getCadastroMedicoStore.secretariasMedico)
    this.getCadastroMedicoStore.setCadastroMedicoMessage(cadastroMedicoMessage)
    this.getSnackbarStore.snackbarValid(cadastroMedicoMessage)
    return cadastroMedicoMessage.success
  }

  async Init() {
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
    this.getTipoUsuario = _.toLower(this.$route.params.tipoConvite)
    const conviteUsuarioParams: any = {
      tipoConvite: this.$route.params.tipoConvite,
      conviteId: this.$route.params.conviteId,
    }

    this.getCadastroMedicoStore.setConviteUsuarioParams(conviteUsuarioParams)
    const conviteResponse = await this.getCadastroMedicoStore.getConviteUsuario()

    if (!conviteResponse.success) {
      this.$router.push('/not-found')
    }

    if (this.getTipoUsuario === 'medicoagendamento') {
      await this.getCadastroMedicoStore.getTermosAceites()
    }

    this.clearLoadingRequest()
  }

  async created() {
    await this.Init()
  }
}
